import { FC } from 'react';

import { Path, Svg, type SvgProps } from './svg';

export const UserKey: FC<SvgProps> = (props) => (
	<Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z"
			fill="currentColor"
		/>
		<Path
			d="M2 21V19C2 16.7909 3.79086 15 6 15H10"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<Path
			d="M17.1022 15.7765L13 20V22H15V20.8H16.2V19.6H17.4L19.2235 17.8978C19.8614 18.0687 20.5379 18.0244 21.1481 17.7716C21.7582 17.5189 22.2679 17.0719 22.5981 16.5C22.9283 15.9281 23.0605 15.2632 22.9743 14.6084C22.8881 13.9537 22.5883 13.3457 22.1213 12.8787C21.6543 12.4117 21.0463 12.1119 20.3916 12.0257C19.7368 11.9395 19.0719 12.0717 18.5 12.4019C17.9281 12.7321 17.4811 13.2418 17.2284 13.852C16.9756 14.4621 16.9313 15.1386 17.1022 15.7765Z"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</Svg>
);
